<template src="./index.html"></template>

<script>
	import data from "./data.js";
	import config from "../../../../../configHttp.js";
	import {
		findPage,contractDel
	} from '@/api/contract';
	import {
		MainFunction
	} from "@/components/util/Function/MainFunction";
	export default {
		data: function() {
			return {
				options: data.options,
				value: "0",
				searchdata: data.searchdata,
				searchlist: data.searchlist,
				outlist: [],
				headData: data.headData,
				pagination: data.pagination,
				tableData: data.tableData,
				shaidiag: false,
				searchdiag: false,
				// 日期控件初始化时间
				dateValue: MainFunction.$getdefultMonth(),
				// 导出传参类型
				outputData: data.outputData,
				// 全部导出
				exportType: "1",
				tablekey: 0,
                selectList:[],
			};
		},
		methods: {
			sizechange(e) {
				this.pagination.pageSize = e;
				this.fetchResultShow();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.fetchResultShow();
			},
			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},
			forRefresh() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},

			forUpdateSearch() {
				this.searchdiag = true;
			},
			closeSearch() {
				this.searchdiag = false;
			},
			saveChange(e) {
				this.searchdiag = false;
			},
			confirmfilter(e) {
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
			},
			closeshaidiag() {
				this.shaidiag = false;
			},
            selectionchange(e){
                this.selectList = e
            },
			// 查询进行发票合计结果(分页)
			fetchResultShow() {
				let params = JSON.parse(JSON.stringify(this.searchdata))
				let search = {
					shenbq: this.dateValue,
				};
				params.taxPeriod = params.taxPeriod.toString();
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = "";
				params.order = "";
				params.search = search;
				findPage(params).then(res => {
					this.pagination.total = res.data.data.total
					this.tableData = res.data.data.records
				})
			},

			// 导出进项发票合计结果
			outPutIInvResult() {
				let selectVal = this.$refs.tablebox.getSelectionval();
				if (selectVal.length == 0) {
					this.$message.info("请选中数据再进行更新取数操作");
					return;
				}
				let fapdms = new Array(selectVal.length);
				selectVal.forEach((v, k) => {
					fapdms[k] = v.fapdm;
				});
				let params = {
					downUrl: config.baseURL + "",
					typeObj: {
						toForm: false,
						fileName: "发票结果" + this.$timestampToStr(new Date(), "yyyyMMdd"),
						fileType: "xlsx",
					},
					params: {
						exportType: this.exportType,
						shenbq: this.dateValue,
						fapdms,
					},
				};
			},
			convertTaxRate(val) {
				if (val != null && val != '') {
					return Number.parseFloat(val) * 100 + "%";
				}
				return "";
			},

            delClick(row) {
                contractDel({id:row.taxval.id}).then(res =>{
                    if (res.data.code == 1) {
                        this.$message.success("删除成功！");
                    } else {
                        this.$message.error(res.data.msg);
                    }
                    this.fetchResultShow();
                })
            },
            batchDel(){
                if (this.selectList.length == 0) {
                    this.$message.error("请选择要删除的数据！");
                }
                let ids = this.selectList.map(item => item.id).join(",");
                contractDel({id:ids}).then(res =>{
                    if (res.data.code == 1) {
                        this.$message.success("删除成功！");
                    } else {
                        this.$message.error(res.data.msg);
                    }
                    this.fetchResultShow();
                })
            },
		},
		components: {},
		created() {
			this.fetchResultShow();
		},
		mounted() {},
		computed: {
			timeDefault() {
				let date = new Date();
				let newDate = date.getFullYear() + "年" + (date.getMonth() + 1) + "期";
			},
		},
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>
